import(/* webpackMode: "eager" */ "/vercel/path0/app/home/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/core/error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/page/home/featured/scroll-to-top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FocusAreaSection"] */ "/vercel/path0/components/page/home/FocusAreaSection/FocusAreaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/page/home/husky-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/page/home/husky-discover.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/page/home/recent-updates/RecentUpdatesSection.tsx");
